module.exports = __webpack_public_path__ + "img/0706-快消种类-下-02.274edfd8.png";